import React from "react";
import { AuthWrapper } from "../components/_shared/AuthWrapper";
import { SigninContent } from "../components/_shared/SigninContent";

export const SignIn = () => {
  return (
    <AuthWrapper>
      <SigninContent isPopup={false} />
    </AuthWrapper>
  );
};
